(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.getElementById('shopify-section-header');
// IMPORTANT: Check if this element exists. If your section ID is different, adjust!
if (!this.header) return;

this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
// Debounce function to limit resize calls
this.debouncedSetHeightVar = this.debounce(this.setHeaderHeightVar.bind(this), 150);

this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);
// Add resize listener to update height if window changes
window.addEventListener('resize', this.debouncedSetHeightVar);

// Set the initial height and create observer
this.setHeaderHeightVar();
this.createObserver();
}

disconnectedCallback() {
if (!this.header) return; // Safety check
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
window.removeEventListener('resize', this.debouncedSetHeightVar); // Remove resize listener
}

// --- NEW or MODIFIED Methods ---

setHeaderHeightVar() {
// Calculate the actual current height of the header section
const headerHeight = this.header.offsetHeight;
// Set the CSS variable on the root element (html)
document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}

// Simple debounce utility function
debounce(func, wait) {
let timeout;
return (...args) => {
const later = () => {
clearTimeout(timeout);
func.apply(this, args);
};
clearTimeout(timeout);
timeout = setTimeout(later, wait);
};
}

// --- Keep Existing Methods ---
createObserver() {
// Make sure observer targets the correct element
if (!this.header) return;
let observer = new IntersectionObserver((entries, observer) => {
// Use intersectionRect if needed, but offsetHeight is often sufficient for padding
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
}, { rootMargin: '0px' }); // Ensure rootMargin is appropriate if needed

observer.observe(this.header);
}

onScroll() {
// Ensure headerBounds is populated before using it
if (!this.headerBounds.bottom && this.headerBounds.bottom !== 0) {
// Maybe run createObserver again or wait if it hasn't run yet
// console.warn('Header bounds not ready for scroll calculation.');
// Or try getting height directly if bounds are unreliable initially
if(!this.header) return; // Guard clause
this.headerBounds.bottom = this.header.offsetHeight; // Approximate if observer is slow
// Be cautious with this fallback
}

const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

// Use a small threshold to prevent jitteriness near the boundary
const stickyThreshold = (this.headerBounds.bottom || this.header.offsetHeight) + 5;


if (scrollTop > this.currentScrollTop && scrollTop > stickyThreshold) {
// Scrolling down past header
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > stickyThreshold) {
// Scrolling up past header bottom
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
// Debounce reveal prevention
window.clearTimeout(this.isScrolling);
this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);
requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= (this.headerBounds.top || 0)) {
// Scrolled back to the top
requestAnimationFrame(this.reset.bind(this));
}


this.currentScrollTop = scrollTop;
}

hide() {
if (!this.header) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (!this.header) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (!this.header) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header?.querySelectorAll('header-menu');
this.disclosures?.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header?.querySelector('details-modal');
// Check if close method exists before calling
if (this.searchModal && typeof this.searchModal.close === 'function') {
this.searchModal.close(false);
}
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
